import { LoadMoreProps } from "@made-people/blueprint-load-more";

export const LoadMore: LoadMoreProps = {
  labels: {
    enabled: false,
  },
  buttonVariants: {
    style: "solid",
    width: "full",
    color: "primary",
  },
};
